export const TEXT_MATERIAL_STORAGE_KEY = 'textmaterial_draft'
